import { c as _c } from "react/compiler-runtime";
import type { TurnstileInstance } from "@marsidev/react-turnstile";
import { useTranslations } from "next-intl";
import { useRef, useState } from "react";
import type { PublicTrialTurnstileController } from "../../register-public.types";
export function usePublicTrialTurnstile() {
  const $ = _c(11);
  const t = useTranslations("trials.register_public.turnstile");
  const ref = useRef(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = nextToken => {
      setToken(nextToken);
      setError(null);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onSuccess = t0;
  let t1;
  if ($[1] !== t) {
    t1 = () => {
      setToken(null);
      setError(t("expired"));
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onExpire = t1;
  let t2;
  if ($[3] !== t) {
    t2 = () => {
      setToken(null);
      setError(t("load_failed"));
    };
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onError = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setToken(null);
      ref.current?.reset();
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const reset = t3;
  let t4;
  if ($[6] !== error || $[7] !== onError || $[8] !== onExpire || $[9] !== token) {
    t4 = {
      ref,
      token,
      error,
      onSuccess,
      onExpire,
      onError,
      reset
    };
    $[6] = error;
    $[7] = onError;
    $[8] = onExpire;
    $[9] = token;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}